export const CS_ACTIONS = [
    { label: 'All CS Actions', name: '', value: '' },
    { label: 'Outbound Call Made', name: 'outbound_call_made', value: 'outbound_call_made' },
    { label: 'Answered', name: 'answered', value: 'answered' },
]